import { useQuery } from '@tanstack/react-query';
import { agentUsersApi, SourceFilter } from '../api/agentUsers';

export const useAgentUserStats = (source?: SourceFilter) => {
  return useQuery({
    queryKey: ['agent-users', 'stats', source ?? 'all'],
    queryFn: () => agentUsersApi.getStats(source),
  });
};
